import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import CarouselManage from '@/components/Admin/CarouselManage.vue';
import NewsManage from '@/components/Admin/NewsManage.vue';
import ProductTypeManage from '@/components/Admin/ProductTypeManage.vue';
import ProductManage from '@/components/Admin/ProductManage.vue';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const activeName = ref('1')

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    type: "border-card",
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: "轮播图管理",
        name: "1"
      }, {
        default: _withCtx(() => [
          (activeName.value === '1')
            ? (_openBlock(), _createBlock(CarouselManage, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "产品类别管理",
        name: "2"
      }, {
        default: _withCtx(() => [
          (activeName.value === '2')
            ? (_openBlock(), _createBlock(ProductTypeManage, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "产品管理",
        name: "3"
      }, {
        default: _withCtx(() => [
          (activeName.value === '3')
            ? (_openBlock(), _createBlock(ProductManage, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "新闻管理",
        name: "4"
      }, {
        default: _withCtx(() => [
          (activeName.value === '4')
            ? (_openBlock(), _createBlock(NewsManage, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})